













import { Component, Vue } from 'vue-property-decorator';
import Container from '@/components/Registration/v2/Container.vue';
import RegistrationCard from '@/components/Registration/v2/Card.vue';
import CardHeader from '@/components/Registration/v2/Header.vue';
import { vxm } from '@/store.vuex';
import VueToastr from '@deveodk/vue-toastr';
import { ChangePasswordRequest } from '@/models/userdata/changepasswordrequest';
import ChangePasswordForm from './ChangePasswordForm.vue';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'ChangePassword',
  components: {
    Container,
    RegistrationCard,
    CardHeader,
    ChangePasswordForm,
  },
})
export default class ChangePassword extends Vue {
  private changePasswordRequest = new ChangePasswordRequest();
  private errors = {
    newPassword: '',
    confirmPassword: '',
  };

  $wlToastr: any;

  private errorString: string = '';

  async changePassword() {
    await vxm.users
      .changeOtpPassword(this.changePasswordRequest)
      .then((resp) => {
        if (resp === true) {
          let signin = vxm.users.completeOtpLogin();
          this.$wlToastr(
            'success',
            this.$t('changepassword.v2.update.sucess'),
            '',
          );
        } else {
          let errorMessage =
            vxm.users.getErrorMesaageLogin ||
            this.$t('changepassword.v2.update.error');
          if('You-have-used-this-password-earlier.-Please-enter-a-new-password'.replace(/-/g, ' ') === errorMessage)
          errorMessage = this.$t('You-have-used-this-password-earlier.-Please-enter-a-new-password');
      
          this.$wlToastr('error', errorMessage, this.$t('profile-accordion.change_password'));
        }
      });
  }
}
